import * as time from 'd3-timer'
import * as d3 from 'd3-selection'
import * as scale from 'd3-scale'

class Rotator {

  constructor (ee, svg, map) {
    this.ee = ee
    this.svg = svg
    this.map = map

    this.timer = time.timer(() => {})
    this.velocity = [0, 0]
    this.time = 0
    this.m1 = [0, 0] // Last known mouse coords

    // These are called by event emitters, make sure they are always
    // properly bound to `this`
    this.start = this.start.bind(this)
    this.drag = this.drag.bind(this)
    this.end = this.end.bind(this)
  }

  start (e) {
    let mapState = this.map.datum()
    this.path = mapState.path
    this.projection = mapState.projection

    this.m0 = d3.pointer(e, this.svg.node()) // Store initial mouse coords
    this.r0 = this.projection.rotate() // And initial rotation

    // For inertia
    this.velocity = [0, 0]
    this.m1 = this.m0
    this.timer.stop()
    this.ee.emit('globe:rotate')
  }

  /*
   * Spins the globe by `dx` `dy`, which are the deltas from the globes original position
   */
  spin (dx, dy, dragging = false) {
    let denominator = 4.0  // Controls how much we spin
      , constraint = 30
      , r1 = [this.r0[0] + dx / denominator, this.r0[1] + dy / denominator]

    r1[1] = r1[1] > constraint  ? constraint  :
                r1[1] < -constraint ? -constraint :
                r1[1]

    this.projection.rotate(r1)

    this.map
        .selectAll('path.feature')
        .attr('d', this.path)

    this.map
        .selectAll('path.graticule')
        .attr('d', this.path)
  }

  drag (e) {
    if (this.m0) {
      let time = performance.now()
        , deltaTime = time - this.time
        , decay = 1 - Math.exp(-deltaTime / 1000)
        , m1 = d3.pointer(e, this.svg.node())
        , dx = m1[0] - this.m0[0]
        , dy = this.m0[1] - m1[1]

      this.spin(dx, dy, true)
      this.map.classed('globe-spinning', true)

      this.velocity = this.velocity.map((d, i) => {
        let deltaPos = m1[i] - this.m1[i]
        return 1000 * (1 - decay) * deltaPos / deltaTime + d * decay
      })

      this.time = time
      this.m1 = m1 // Last known mouse position
    }
  }

  stop () {
    this.timer.stop()
  }

  end () {
    if (this.velocity[0] * this.velocity[0] + this.velocity[1] * this.velocity[1] < 100) {
      // Not enough velocity to keep spinning
      this.map.classed('globe-spinning', false)
      return this.timer.stop()
    }

    const referenceTime = 3000
        , limit = 1.0001
        , log = -Math.log(1 - 1 / limit)
        , xScale = scale.scaleLinear().domain([0, 1]).range([this.m1[0], this.m1[0] + this.velocity[0]])
        , yScale = scale.scaleLinear().domain([0, 1]).range([this.m1[1], this.m1[1] + this.velocity[1]])

    this.timer.restart(e => {
      this._tween = limit * (1 - Math.exp(-log * e / referenceTime))
      if (this._tween > .95) {
        // Slowed down enough we can indicate it's not spinning
        this.map.classed('globe-spinning', false)
      }

      if (this._tween > 1) {
        this.timer.stop()

        this.velocity = [0, 0]
      }

      let dx = xScale(this._tween) - this.m0[0]
        , dy = this.m0[1] - yScale(this._tween)

      this.spin(dx, dy)
    })
  }
}

export default Rotator
